import { Injectable } from '@angular/core';
import { HttpClientCustom } from '../custom/http-client';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { Client } from 'src/providers/client/client';
import { ReportIssue } from 'src/providers/report-issue/report-issue';
import { WindowService } from 'src/shared/providers/window.service';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { TaskPage } from 'src/pages/tasks/task/task';

@Injectable()
export class TasksService {

  allTasks: any[] = [];
  tasksLoaded = false;
  linkedTasks: any[] = [];

  constructor(
    private httpClient: HttpClientCustom,
    private storage: TidyStorage,
    private client: Client,
    private reportIssue: ReportIssue,
    private windowService: WindowService,
    private rightSidePanelService: RightSidePanelService,
    private navCtrl: CustomNavController
  ) {}

  async goToTask(taskId: number) {
    const task = this.allTasks.find(t => t.id === taskId);
    const params = {
      cameFromJobPage: true,
      issue: task,
      addressResponse: [await this.client.getAddresses()].flat(),
      issueReportTypes: await this.reportIssue.getIssueReportTypes()
    };
    let dialogParams = await this.storage.retrieve('dialog-params');
    dialogParams = { ...dialogParams, ...params };
    await this.storage.save('dialog-params', dialogParams);
    if (this.windowService.isDesktopRes) {
      await this.storage.save('dialog-right-side-open', true);
      this.rightSidePanelService.navigateTo('task', params, TaskPage, false);
    } else {
      this.navCtrl.navigateForward('task', params);
    }
  }


}
